import classNames from '@sindresorhus/class-names';

import {useAuthorizedProfile} from '@web-catalog/store/auth';

import {SpriteIcon} from '@web-catalog/ui-kit/SpriteIcon';

import styles from './Avatar.module.scss';

type Props = {
  size?: number;
  className?: string;
};

export const Avatar = ({className, size = 36}: Props) => {
  const userInfo = useAuthorizedProfile();

  if (!userInfo) {
    return null;
  }
  if (userInfo?.photo_200) {
    return (
      <img
        alt={`Аватар ${userInfo.first_name || 'пользователя'}`}
        src={userInfo.photo_200}
        className={classNames(styles.image, className)}
        width={size}
        height={size}
      />
    );
  }
  return <SpriteIcon svg="defaultAvatar" size={size} className={className} />;
};
